<ng-container *ngIf="scorecardDescription">
  <div
    class="scorecard-description-carousel-header"
    [ngClass]="{
      'scorecard-description-carousel-header-incompleted': !scorecardDescription.isCompleted,
      'scorecard-description-carousel-header-streak': isStreakView,
    }"
  >
    <div class="scorecard-description-header-wrapper">
      <div class="scorecard-description-back-btn d-flex d-sm-none" (click)="back()">
        <span class="ps-3 material-icons">arrow_back_ios</span>
      </div>

      <div class="scorecard-description-name fw-bold">{{ scorecardDescription?.currentScorecard?.Content[0]?.Name }}</div>
    </div>
    <button class="scorecard-description-close-btn d-sm-flex d-none">
      <i class="material-symbols-outlined" (click)="closeModal()">close</i>
    </button>

    <div class="scorecard-carousel-container" *ngIf="!isStreakView">
      <div class="scorecard-img-carousel-track" #track>
        <div
          class="scorecard-img-carousel-item"
          *ngFor="let sc of scorecardDescription.scorecardFamily; index as index"
          (click)="setSelected(index)"
          [ngStyle]="{
            width: itemWidth + 'px',
            height: itemWidth + 'px',
          }"
          [ngClass]="{
            active: scorecardDescription?.currentScorecard?.ScorecardId === sc.ScorecardId,
            completed: sc.Completed,
            single: !scorecardDescription?.showLinkedScoreCard,
            selected: currentPosition === index,
          }"
        >
          <img src="{{ sc?.Image | contentImage: '7' : 'badge' }}" />
        </div>
      </div>
    </div>
    <div
      class="scorecard-description-content"
      [ngClass]="{
        'scorecard-description-content-completed': scorecardDescription.isCompleted,
      }"
    >
      <div class="scorecard-description-description" [ngClass]="{ 'd-none': scorecardDescription.isCompleted }">
        <ng-container *ngIf="scorecardDescription.isLocked">
          {{
            'scorecard.modal.locked.description'
              | translate: { parentScorecardName: scorecardDescription.parentScorecard?.Content[0].Name }
          }}
        </ng-container>
        <ng-container *ngIf="!scorecardDescription.isLocked">
          {{ scorecardDescription.currentScorecard?.Content[0]?.ShortDescription }}
        </ng-container>
      </div>
      <ng-container *ngIf="!scorecardDescription.isCompleted && !isStreakView">
        <div class="scorecard-description-prize">
          <ng-container *ngIf="hasPrizeSelection; else noPrizeSelection">
            <div *ngIf="hasPrizeSelection" class="prize-content d-flex">
              <span class="scorecard-description-modal-prize-v2 prize-label fw-bold">{{ 'scorecard.prize' | translate }}</span>
              <span class="scorecard-description-list-prize">
                {{ 'scorecard.choose.prize' | translate }}
              </span>
            </div>
          </ng-container>
          <ng-template #noPrizeSelection>
            <div
              class="prize-content"
              [ngClass]="{
                'prize-content-long-description':
                  scorecardDescription?.currentScorecard?.Content[0]?.PrizeDescription?.length > 59,
              }"
            >
              <span class="prize-label fw-bold"> {{ 'scorecard.prize' | translate }}</span>
              <span *ngIf="!hasPrizeSelection" class="prize-content-description">{{
                scorecardDescription.currentScorecard?.Content[0]?.PrizeDescription
              }}</span>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="!isSponsorInBody && scorecardDescription.currentScorecard?.Sponsor?.SponsorImage">
      <div class="scorecard-description-sponsor" *ngIf="!scorecardDescription?.currentScorecard?.Locked">
        <fgbcl-scorecard-sponser-view [scorecard]="scorecardDescription.currentScorecard" />
      </div>
    </ng-container>
  </div>
</ng-container>
